

import merge from "lodash/merge";

declare var Hammer: any;
class QuoteTable {
  table_config: any
  timer: any
  nowX:any = 0
  constructor(options: any) {
    this.table_config = merge(this.table_config, options);
  }

  // 初始化表格 
  async init(isReturn?:boolean) {
    let self = this;
    if(isReturn){
      let data = await self.makeTable(true)
      return data
    }else{
      let data = await self.makeTable(false)
      return data
    }
    
  }

  destroy() {
    let self = this;
    clearInterval(self.timer)
    $(`#${self.table_config.ele}`).html('')
  }

  getUrl(url: any, params: any) {
    return `${url}&fid=${params.sortkey}&po=${params.sortval}&pz=${params.size}`
  }

  async getDataAjax(url: any) {
    // Ajax数据请求
    let self = this
    let backdata = new Promise(function (res, rej) {
      try {
        $.ajax({
          url: url,
          type: 'GET',
          timeout: 15000,
          dataType: 'jsonp',
          success: function (data) {
            // 返回成功数据
            res(data)
          },
          error: function (err) {
            rej([])
          }
        });
      } catch (error) {
        // 错误处理
      }
    })

    return backdata.then(function (v: any) {
      return v
    }).catch(function (ErrMsg: any) {
      return []
    });

  }

  async makeTable(isReturn:boolean) {
    let self = this;
    let url ;
    if(self.table_config.isProcess){
      url = self.table_config.getUrl(self.table_config.api, self.table_config.params)
    }else{
      url = self.getUrl(self.table_config.api, self.table_config.params)
    }
    let tableData = await self.getDataAjax(url)
    tableData = self.dealWithArray(tableData,self.table_config.params.sortkey)
    let ele = $(`#${self.table_config.ele}`)
    ele.html('')
    ele.append($(`<div class='table-title'><div class='title_left'><table></table></div><div class='title_right'><table></table></div></div><div class='table-container'><div class='table_left'><table></table></div><div class='table_right'><table></table></div></div>`))
    let screenWidth = document.documentElement.offsetWidth > 450 ? 450 : document.documentElement.offsetWidth;
    let rightwidth = 2 / 3 * screenWidth / self.table_config.right_tds * (self.table_config.item.length - 1)
    $(`#${self.table_config.ele} .table_right`).width(rightwidth)
    $(`#${self.table_config.ele} .title_right`).width(rightwidth)
    self.leftTitle(tableData)
    self.rightTitle(tableData)
    // 生成左侧表格
    self.leftTable(tableData)

    // 生成右侧表格
    self.rightTable(tableData)

    // 给表格注册事件
    self.bindFun(true)

    // 注册定时器
    self.setTimer()
    if(isReturn){
      return tableData
    }
  }

  leftTitle(data:any){
    // 左侧标题
    let self = this
    let _left_title = $(`#${self.table_config.ele} .title_left`).find('table');
    let _tbody = $(`<tbody></tbody>`)
    let _html = `<tr>${self.table_config.item[0].html(null)}</tr>`
    _tbody.html(_html)
    _left_title.append(_tbody)
  }

  rightTitle(data:any){
    let self = this
    let title_right = $(`#${self.table_config.ele} .title_right`).find('table');
    let _tbody = $(`<tbody></tbody>`)

    let tr = ''
    // 生成右侧表格的表头部分并导入
    self.table_config.item.forEach((_item: any, _index: number) => {
      if (_index !== 0) {
        tr += `${_item.html(null)}`
      }
    })
    tr = `<tr>${tr}</tr>`
    // 生成右侧表格的后续部分
    _tbody.html(tr)
    title_right.append(_tbody)
  }

  leftTable(data: any) {
    // 左侧菜单
    let self = this
    let _left_table = $(`#${self.table_config.ele} .table_left`).find('table');
    let _tbody = $(`<tbody></tbody>`)
    let _html = ``
    let res
    try {
      if(self.table_config.isProcess){
        res = self.table_config.dataProcess(data)
        res.forEach((item: any, index: number) => {
          let _tr = self.table_config.item[0].html(item)
          _html += `<tr data-code='${item.dm || item.f57 || item?.f12}' data-market='${item.sc || item.f107 || item?.f13}'>${_tr}</tr>`
        })
      }else{
        res = data.data.diff
        res.forEach((item: any, index: number) => {
          let _tr = self.table_config.item[0].html(item)
          _html += `<tr data-code='${item?.f12}' data-market='${item?.f13}'>${_tr}</tr>`
        })
      }
    } catch (error) {
      
    }
    _tbody.html(_html)
    _left_table.append(_tbody)
  }

  rightTable(data: any) {
    // 右侧表格
    let self = this
    let table_right = $(`#${self.table_config.ele} .table_right`).find('table');
    let _tbody = $(`<tbody></tbody>`)
    let tr = ''
    //接口数据处理
    let res
    try {
      if(self.table_config.isProcess){
        res = self.table_config.dataProcess(data)
        res.forEach((data: any, index: number) => {
          let _tr = ''
          self.table_config.item.forEach((_item: any, _index: number) => {
            if (_index !== 0) {
              _tr += `${_item.html(data)}`
            }
          })
          _tr = `<tr data-code='${data.dm || data.f57 || data?.f12}' data-market='${data.sc || data.f107 || data?.f13}'>${_tr}</tr>`
          tr += _tr
        })
      }else{
        res = data.data.diff
        // 生成右侧表格的后续部分
        res.forEach((data: any, index: number) => {
          let _tr = ''
          self.table_config.item.forEach((_item: any, _index: number) => {
            if (_index !== 0) {
              _tr += `${_item.html(data)}`
            }
          })
          _tr = `<tr data-code='${data?.f12}' data-market='${data?.f13}'>${_tr}</tr>`
          tr += _tr
        })
      }
    } catch (error) {
      // console.log(error)
      console.log('返回data数据为空')
    }
    
    _tbody.html(tr)
    table_right.append(_tbody)
  }

  getMonths(time:any){
    let months = 0
  
    if(time.indexOf('M') > -1){
      months = parseInt(time.replace('M', ''))
    }
    if(time.indexOf('Y') > -1){
      months = parseInt(time.replace('Y', '')) * 12
    }  
  
    return months
  }

  flatten(arr:any){
    let self = this
    return arr.reduce((pre:any, cur:any)=>{
      return pre.concat(Array.isArray(cur) ? self.flatten(cur) : cur)
    }, [])
  }


  dealWithArray(tableData:any,sortKey:string){
    let self = this;
    if(self.table_config.keyword == 'globalTips'){
      // let tempTableData:any = []
      let result:any = []
      if(tableData?.data?.diff && tableData.data.diff.length > 0){
        // tempTableData = tableData.data.diff.sort((v1:any,v2:any)=>{
        //   return v2[sortKey] - v1[sortKey]
        // })
        let temp:any = []
        result = tableData.data.diff.reduce((group:any,item:any)=>{
          if(item?.f14.indexOf("通胀") > -1){
              temp.push(item)
          }else{
            if(group[item?.f486]){
            
              group[item.f486].push(item)
            }else{
              group[item?.f486] = []
              group[item.f486].push(item)
            }
          }
          
          return group
        },{})
        result["temp"] = temp
      }
      
      let flatResult:any = self.flatten(Object.values(result))

      return {
        ...tableData,
        data:{
          total: flatResult.length,
          diff: flatResult
        }
      }
    } else if (self.table_config.keyword == 'globalbond'){
      // let tempTableData:any = []
      let result:any = []
      if(tableData?.data?.diff && tableData.data.diff.length > 0){
        // tempTableData = tableData.data.diff.map((item:any)=>{
        //   if(!(item.f2 == null || item.f2 == "-" || item.f2 == undefined)){
        //     return item
        //   }else if(((item.f2 == null || item.f2 == "-" || item.f2 == undefined) && (item.f493 & 16) == 0)){
        //     return null
        //   }else if((item.f2 == null || item.f2 == "-" || item.f2 == undefined) && (item.f493 & 16) != 0){
        //     item.f2 = 0
        //     return item
        //   }
        // })
        // tempTableData = tempTableData.filter(Boolean)
        // tempTableData = tempTableData.sort((v1:any,v2:any)=>{
        //   return v2[sortKey] - v1[sortKey]
        // })
        result = tableData.data.diff.reduce((group:any,item:any)=>{
          if(group[item?.f486]){
            group[item?.f486].push(item)
          }else{
            group[item?.f486] = []
            group[item?.f486].push(item)
          }
          return group
        },{})
      }

      let flatResult:any = self.flatten(Object.values(result))

      return {
        ...tableData,
        data:{
          total: flatResult.length,
          diff: flatResult
        }
      }
    } else if(self.table_config.keyword == "tips"){
      let newTableData:any = []
      if(tableData?.data?.diff && tableData.data.diff.length > 0){
          // newTableData = tableData.data.diff.sort((v1:any,v2:any)=>{
          //   return this.getMonths(v1?.f487) - this.getMonths(v2?.f487)
          // })
        newTableData = tableData.data.diff
        if(self.table_config.type != "allTips"){
          newTableData = tableData.data.diff.slice(0,8)
          $(".hsqsc").css("padding-bottom",0)
        }
    }

      return {
        ...tableData,
        data:{
          total: newTableData.length,
          diff: newTableData
        }
      }
    }else if(self.table_config.keyword == "ratelist" && self.table_config.sortArray instanceof Array && self.table_config.sortArray.length > 0){
      let result:any = []
      if(tableData?.data?.diff && tableData.data.diff.length > 0){
        let temp_time = tableData.data.diff.map((v:any)=>v?.f124)
        let latest_updateTime = Math.max(...temp_time)
        self.table_config.sortArray.map((item:any)=>{
          let cn_temp = tableData.data.diff.find((v1:any)=>v1?.f14.indexOf(item) > -1 && v1?.f14.indexOf("中国") > -1)
          let us_temp = tableData.data.diff.find((v2:any)=>v2?.f14.indexOf(item) > -1 && v2?.f14.indexOf("美国") > -1)

          result.push({
            f1:cn_temp.f1,
            f12:cn_temp?.f12,
            f13:cn_temp?.f13,
            "year":item,
            "cn_rate":cn_temp.f2,
            "us_rate":us_temp.f2,
            "rate_spread":cn_temp.f2 - us_temp.f2,
            latest_updateTime
          })
        })
      }
      return {
        ...tableData,
        data:{
          total:result.length,
          diff: result
        }
      }
    }else{
      return tableData
    }
  }

  bindFun(isSort:boolean) {
    // 给表格注册事件
    let self = this
    let dom:any = document.getElementById(`${self.table_config.ele}`);
    let _table: any = dom.querySelector('.table_right');
    let _title:any = dom.querySelector('.title_right');
    let _right_title:any = _title.querySelector('table')
    let _left_title :any = dom.querySelector('.title_left')
    let _left_table: any = dom.querySelector('.table_left');
    let _right_table = _table.querySelector('table');
    let _container = $(`#${self.table_config.ele}`).children("div").get(1)!
    let _title_container = $(`#${self.table_config.ele}`).children("div").get(0)!
    let left_title:any = dom.querySelector('.title_left')
    // 动态设置表格高度
    _container.style.height = _left_table.offsetHeight  + 'px';
    _title_container.style.height = left_title.offsetHeight + 'px';
    
    let endX = 0
    let nowX = self.nowX
    let screenWidth = document.documentElement.offsetWidth > 450 ? 450 : document.documentElement.offsetWidth;
    let showWith = 2 * screenWidth / 3
    let timer:any

    let bindObj = {
      _right_table: _right_table,
      _right_title:_right_title,
      _left_table: _left_table,
      _left_title:_left_title,
      endX: endX,
      nowX: nowX,
      screenWidth: screenWidth,
      showWith: showWith,
      liWidth: showWith / self.table_config.right_tds,
      tableWith:_right_table.offsetWidth,
      timer:timer
    }

    self.setTransform(bindObj)
    self.listAlignment(bindObj)

    var hemmertime = new Hammer(_right_table)
    // 监听 水平方向的滑动
    hemmertime.get('pan').set({ direction: Hammer.DIRECTION_HORIZONTAL });

    hemmertime.on('panstart', function (e: any) {
      bindObj._left_table.classList.add('table_shadow')
      bindObj._left_title.classList.add('table_shadow')
      _right_table.style.transition = 'none';
      _right_title.style.transition = 'none';
    })

    hemmertime.on('panmove', function (e: any) {
      bindObj.endX = e.deltaX
      let _moveX = bindObj.nowX + bindObj.endX
      if(_moveX > 0){
        _moveX = 0
      }

      if(_moveX + bindObj.tableWith - bindObj.liWidth*self.table_config.right_tds < 0){
        _moveX = -bindObj.tableWith + bindObj.liWidth*self.table_config.right_tds
      }
      bindObj._right_table.style.transform = 'translateX(' + _moveX + 'px)';
      bindObj._right_title.style.transform = 'translateX(' + _moveX + 'px)';
    })

    hemmertime.on('panend', function (e: any) {
      bindObj.nowX = bindObj.endX + bindObj.nowX
      bindObj._left_table.classList.remove('table_shadow')
      bindObj._left_title.classList.remove('table_shadow')
      _right_table.style.transition = 'transform .5s cubic-bezier(.17,.67,.84,.90)';
      _right_title.style.transition = 'transform .5s cubic-bezier(.17,.67,.84,.90)';
      self.setTransform(bindObj)
      self.listAlignment(bindObj)
      self.nowX = bindObj.nowX
    })



    var hemmertime1 = new Hammer(_right_title)
    hemmertime1.on('panstart', function (e: any) {
      bindObj._left_table.classList.add('table_shadow')
      bindObj._left_title.classList.add('table_shadow')
      _right_table.style.transition = 'none';
      _right_title.style.transition = 'none';
    })

    hemmertime1.on('panmove', function (e: any) {

      bindObj.endX = e.deltaX
          let _moveX = bindObj.nowX + bindObj.endX
          if(_moveX > 0){
            _moveX = 0
          }
    
          if(_moveX + bindObj.tableWith - bindObj.liWidth*self.table_config.right_tds < 0){
            _moveX = -bindObj.tableWith + bindObj.liWidth*self.table_config.right_tds
          }
      bindObj._right_table.style.transform = 'translateX(' + _moveX + 'px)';
      bindObj._right_title.style.transform = 'translateX(' + _moveX + 'px)';
    })

    hemmertime1.on('panend', function (e: any) {
      bindObj.nowX = bindObj.endX + bindObj.nowX
      bindObj._left_table.classList.remove('table_shadow')
      bindObj._left_title.classList.remove('table_shadow')
      _right_table.style.transition = 'transform .5s cubic-bezier(.17,.67,.84,.90)';
      _right_title.style.transition = 'transform .5s cubic-bezier(.17,.67,.84,.90)';
      self.setTransform(bindObj)
      self.listAlignment(bindObj)
      self.nowX = bindObj.nowX
    })

    if(isSort){
      self.bindSort(`#${self.table_config.ele} .title_right`)
      $(`#${self.table_config.ele} .table_left`).on('click', 'tr', function (e) {
        if (this.getAttribute('data-code') == '' || this.getAttribute('data-code') == null || this.getAttribute('data-code') == undefined) {

        } else {
          //window.location.href = `/quote/stock/${this.getAttribute('data-market')}.${this.getAttribute('data-code')}.html`
          let m = this.getAttribute('data-market') == 128 ? 116 : this.getAttribute('data-market')
          window.open(`/quote/stock/${m}.${this.getAttribute('data-code')}.html`); 
        }
      })

      $(`#${self.table_config.ele} .table_right`).on('click', 'tr', function (e) {
        if (this.getAttribute('data-code') == '' || this.getAttribute('data-code') == null || this.getAttribute('data-code') == undefined) {

        } else {
          //window.location.href = `/quote/stock/${this.getAttribute('data-market')}.${this.getAttribute('data-code')}.html`
          let m = this.getAttribute('data-market') == 128 ? 116 : this.getAttribute('data-market')
          window.open(`/quote/stock/${m}.${this.getAttribute('data-code')}.html`); 
        }
      })
    }
  }

  setTransform(opsions: any) {
    // 滑动归位
    if (opsions.nowX > 0) {
      opsions.nowX = 0
    } else if (opsions.nowX + opsions._right_table.offsetWidth - opsions.showWith < 0) {
      opsions.nowX = -opsions._right_table.offsetWidth + opsions.showWith
    } else {
    }
    opsions._right_table.style.transform = 'translateX(' + opsions.nowX + 'px)';
    opsions._right_title.style.transform = 'translateX(' + opsions.nowX + 'px)';
  }

  listAlignment(opsions: any) {
    // 列对齐
    let _x = Math.abs(opsions.nowX) % opsions.liWidth
    if (_x > 0) {
      if (_x < (opsions.liWidth / 2)) {
        // 左侧列表不及1格
        opsions.nowX = opsions.nowX + _x
      } else {
        opsions.nowX = opsions.nowX + _x - opsions.liWidth
      }
    }
    opsions._right_table.style.transform = 'translateX(' + opsions.nowX + 'px)';
    opsions._right_title.style.transform = 'translateX(' + opsions.nowX + 'px)';
  }

  bindSort(e: any) {
    // 绑定排序事件
    let self = this
    let tabdom = $(e).find('tr')[0]
    tabdom.addEventListener('click', function (e: any) {
      if(e.target.classList.length != 0){
        // 清除自动刷新定时器
        clearInterval(self.timer)
        // 判断点击的 tab 标签是否有class，没有则代表之前是标准，并重置所有 tab 现有的 class
        // 列表页面的顺序，正序填0，倒序填1，默认为1。
        // 被点击tab标签之前并未点击过 点击后变为降序
        if (e.target.classList.contains('sort_asc')) {
          // 该标签之前是升序 点击后变为降序
          e.target.classList.remove('sort_asc')
          e.target.classList.add('sort_des')
          self.table_config.params.sortval = self.table_config.sortdesc
        } else if (e.target.classList.contains('sort_des')) {
          // 改标签质之前是降序 点击后改为升序
          e.target.classList.remove('sort_des')
          e.target.classList.add('sort_asc')
          self.table_config.params.sortval = self.table_config.sortasc
        } else {
          for (let i = 0; i < tabdom.children.length; i++) {
            if (tabdom.children[i].classList.contains('sort_asc')){
              tabdom.children[i].classList.remove('sort_asc')
              tabdom.children[i].classList.toggle('sort_normal',true)
            }else if(tabdom.children[i].classList.contains('sort_des')){
              tabdom.children[i].classList.remove('sort_des')
              tabdom.children[i].classList.toggle('sort_normal',true)
            }
            
          }
          e.target.classList.remove('sort_normal')
          e.target.classList.add('sort_des')
          self.table_config.item.forEach((item: any, index: any) => {
            if (item.title == e.target.innerHTML) {
              // 获取当前点击标签
              self.table_config.params.sortkey = item.sortitem.key;
              self.table_config.params.sortval = self.table_config.sortdesc // 点击后默认降序
            }
          })
        }
        // 点击排序后 ，计时器重新计时
        self.setTimer()
        // reloadData点击排序后重新加载新数据
        self.reloadData()
      }
    })
  }

  // 数据重载
  async reloadData() {
    // 重新加载数据并渲染
    let self = this;
    let url;
    if(self.table_config.isProcess){
      url = self.table_config.getUrl(self.table_config.api,self.table_config.params)
    }else{
      url = self.getUrl(self.table_config.api, self.table_config.params)
    }
    let tableData = await self.getDataAjax(url)
    tableData = self.dealWithArray(tableData,self.table_config.params.sortkey)

    let data:any;
    try {
      if(self.table_config.isProcess){
        data = self.table_config.dataProcess(tableData)
      }else{
        data = tableData.data.diff
      }
    } catch (error) {
      
    }

    if(data && data.length > 0) {
      // 左侧表格数据替换
      let _left_td = $(`#${self.table_config.ele} .table_left`).find('tr');
      if(self.table_config.isProcess){
        for (let i = 0; i < _left_td.length; i++) {
          _left_td[i].setAttribute('data-code', data[i].dm || data[i].f57 || data[i]?.f12)
          _left_td[i].setAttribute('data-market', data[i].sc || data[i].f107 || data[i]?.f13)
          _left_td[i].innerHTML = self.table_config.item[0].html(data[i])
        }
      }else{
        for (let i = 0; i < _left_td.length; i++) {
          _left_td[i].setAttribute('data-code', data[i]?.f12)
          _left_td[i].setAttribute('data-market', data[i]?.f13)
          _left_td[i].innerHTML = self.table_config.item[0].html(data[i])
        }
      }

      // 右侧表格数据替换
      let _right_td = $(`#${self.table_config.ele} .table_right`).find('tr');
      if(self.table_config.isProcess){
        for (let j = 0; j < _right_td.length; j++) {
          let _html = ''
          self.table_config.item.forEach((_item: any, _index: number) => {
            if (_index !== 0) {
              _html += (`${_item.html(data[j])}`)
            }
          })
          _right_td[j].setAttribute('data-code', data[j].dm || data[j].f57 || data[j]?.f12)
          _right_td[j].setAttribute('data-market', data[j].sc || data[j].f107 || data[j]?.f13)
          _right_td[j].innerHTML = _html
        }
      }else{
        for (let j = 0; j < _right_td.length; j++) {
          let _html = ''
          self.table_config.item.forEach((_item: any, _index: number) => {
            if (_index !== 0) {
              _html += (`${_item.html(data[j])}`)
            }
          })
          _right_td[j].setAttribute('data-code', data[j]?.f12)
          _right_td[j].setAttribute('data-market', data[j]?.f13)
          _right_td[j].innerHTML = _html
        }
      }
    }
  }

  async showMore(num: number) {
    // 加载更多
    let self = this
    self.table_config.params.size = Number(self.table_config.params.size) + Number(num)
    let url ;
    if(self.table_config.isProcess){
      url = self.table_config.getUrl(self.table_config.api, self.table_config.params)
    }else{
      url = self.getUrl(self.table_config.api, self.table_config.params)
    }
    let tableData = await self.getDataAjax(url)
    let originData = tableData
    tableData = self.dealWithArray(tableData,self.table_config.params.sortkey)
    $(`#${self.table_config.ele} .table_right`).html('<table></table>')
    $(`#${self.table_config.ele} .table_left`).html('<table></table>')
    let screenWidth = document.documentElement.offsetWidth > 450 ? 450 : document.documentElement.offsetWidth;
    let rightwidth = 2 / 3 * screenWidth / self.table_config.right_tds * (self.table_config.item.length - 1)
    $(`#${self.table_config.ele} .table_right`).width(rightwidth)
    $(`#${self.table_config.ele} .title_right`).width(rightwidth)

    // 生成左侧表格
    self.leftTable(tableData)
    // 生成右侧表格
    self.rightTable(tableData)
    // 给表格注册事件
    self.bindFun(false)
    return originData
  }

  async loadDataLength(){
    let self = this
    let url ;
    if(self.table_config.isProcess){
      url = self.table_config.getUrl(self.table_config.api, self.table_config.params)
    }else{
      url = self.getUrl(self.table_config.api, self.table_config.params)
    }
    let tableData = await self.getDataAjax(url)
    return tableData
  }

  setTimer() {
    // 设置定时器  时间间隔大于 0 说明有自刷
    let self = this
    if (self.table_config.refresh > 0) {
      self.timer = setInterval(function () {
        self.reloadData()
      }, self.table_config.refresh * 1000)
    }
  }
}

export default QuoteTable